const bannerVideos = document.querySelectorAll('.fn-banner-video');

// Liegt neben dem Bannerbild eine gleichnamige .mp4, zeigt das Template ein
// Video. Es startet erst, wenn das Banner ins Bild kommt - so laedt es nicht
// bei jedem Seitenaufruf mit.
if (bannerVideos.length) {
    const starten = (video) => {
        const versuch = video.play();
        if (versuch && versuch.catch) {
            versuch.catch(() => {});
        }
    };

    if (window.IntersectionObserver) {
        const beobachter = new IntersectionObserver((eintraege) => {
            eintraege.forEach((eintrag) => {
                if (eintrag.isIntersecting) {
                    starten(eintrag.target);
                } else {
                    eintrag.target.pause();
                }
            });
        }, { rootMargin: '200px' });

        bannerVideos.forEach((video) => beobachter.observe(video));
    } else {
        bannerVideos.forEach(starten);
    }
}
